import { Card, Form } from 'antd';
import React from 'react'

function AccountingInformation({data}) {
  return (
    <Card title="Accounting Information">
      <Form colon={false} labelCol={{ span: 8 }} wrapperCol={{ span: 8}}>
        <Form.Item label="Current Bank Balance">
            <p>{data?.currentBankBalance}</p>
        </Form.Item>
        <Form.Item label="As of">
            <p>{data?.asOf}</p>
        </Form.Item>
        <Form.Item label="Next Deposit Number">
            <p>{data?.nextDepositNumber}</p>
        </Form.Item>
      </Form>
    </Card>
  )
}

export default AccountingInformation;
